import { Avatar, Flex, IconButton, Image, Text } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import { FC, useState } from 'react';

import ArrowLeftIcon from '@/assets/icons/ic-arrow-left.svg';

import { EditMessageInput } from '@/components/ui/shared/chat/ChatPopup/components/EditMessageInput';
import { MessageInput } from '@/components/ui/shared/chat/ChatPopup/components/MessageInput';
import { MessagesBox } from '@/components/ui/shared/chat/ChatPopup/components/MessagesBox';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryChatChannelOfUser } from '@/queries/event-chat-channels';
import { ChatMessages } from '@/resources/ChatMessages';
import { ThinProfile } from '@/resources/ThinProfile';

interface IChatChannel {
  profile: ThinProfile;
  setProfileSelected: (profile: ThinProfile | null) => void;
}

export const ChatChannel: FC<IChatChannel> = ({ profile, setProfileSelected }) => {
  const [editMessage, setEditMessage] = useState<ChatMessages | null>(null);
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const { data } = useResource(queryChatChannelOfUser(profile.user.id, eventId));

  return (
    <Flex h="full" w="full" px={{ base: 8, md: 5 }} py={6} flexDirection="column">
      <Flex w="full">
        <IconButton
          size="sm"
          onClick={() => setProfileSelected(null)}
          variant="unstyled"
          aria-label="edit"
          icon={<ArrowLeftIcon />}
        />
        <Flex ml={2} cursor="pointer" key={profile.id}>
          {!profile.avatar && <Avatar bg="violet.500" color="white" name={profile.fullName} />}
          {profile.avatar && (
            <Image src={profile.avatar} alt={profile.fullName} width={10} height={10} style={{ borderRadius: '50%' }} />
          )}
          <Flex ml={2} flexDirection="column" justifyContent="center">
            <Text fontWeight="bold" fontFamily="heading">
              {profile.fullName}
            </Text>
            <Text fontSize="xs">{profile.title}</Text>
          </Flex>
        </Flex>
      </Flex>
      <MessagesBox setEditMessage={setEditMessage} channel={data} profile={profile} />
      {!editMessage && <MessageInput channel={data} profile={profile} />}
      {editMessage && (
        <EditMessageInput message={editMessage} setEditMessage={setEditMessage} channel={data} profile={profile} />
      )}
    </Flex>
  );
};
